import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  TextField,
} from "@material-ui/core";
import { Asterisk } from "phosphor-react";
import React, { useContext } from "react";

//Validators
import { useFormik } from "formik";
import { useState } from "react";
import { X } from "react-feather";
import * as yup from "yup";
import { fpatch } from "../../API/callsAPI";
import useStyles from "../ProjectPage/ProjectPageModals/ProjectPageNewProjectModal.styles";
import HelperText from "../Utilities/HelperText/HelperText";
import ModalTitleAndButtons from "../Utilities/ModalTitleAndButtons/ModalTitleAndButtons.component";
import { MovieColabContext } from "../../Context/MovieColabContext";
//
export default function EditProfileModal({ handleClose, setSnackValue }) {
  const classes = useStyles();
  const { loggedInUser } = useContext(MovieColabContext);

  const [thumbnail, uploadThumbnailSet] = React.useState();
  const [thumbnailTouched, setThumbnailTouch] = React.useState(false);
  const [loader, setLoader] = React.useState(false);

  const [isHovered, setIsHovered] = useState(false);

  const handleThumbnailUpload = (e) => {
    let file = e.target.files[0];
    uploadThumbnailSet(file);
    setThumbnailTouch(true);
  };

  const removeThumbnail = () => {
    uploadThumbnailSet(null);
    setThumbnailTouch(false);
    setIsHovered(false);
  };

  //Validators
  const NewProfileValidationSchema = yup.object({
    first_name: yup
      .string("String required")
      .label("first_name")
      .min(1, "Too Short!")
      .max(50, "Maximum Character Limit: 50")
      .required("This is a required field"),

    last_name: yup
      .string("String required")
      .label("abbreviation")
      .max(15, "Maximum Character Limit: 15")
      .required("This is a required field"),
  });
  const formik = useFormik({
    initialValues: {
      first_name: loggedInUser?.first_name ?? "",
      last_name: loggedInUser?.last_name ?? "",
    },
    validationSchema: NewProfileValidationSchema,
    onSubmit: async (values) => {
      const formData = new FormData();

      setLoader(true);
      formData.append("first_name", values.first_name);
      formData.append("last_name", values.last_name);
      thumbnail && formData.append("avatar", thumbnail);

      try {
        const editProfile = {
          url: `user/${loggedInUser?.id}/`,
          data: formData,
        };
        const editProfileRes = await fpatch(editProfile);
        if (editProfileRes.status === 200 || 201) {
          setLoader(false);
          /* setSnackValue({
            isOpen: true,
            message: `SuccessFully edited "${editProfileRes.data.name}"`,
            isError: false,
          }); */
        }
        window.location.reload();
      } catch (error) {
        setLoader(false);
        /* setSnackValue({
          isOpen: true,
          message: `${error}`,
          isError: true,
        }); */
      }
    },
  });

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <form onSubmit={formik.handleSubmit}>
            <ModalTitleAndButtons
              name="Profile"
              type="Edit"
              closeModal={() => handleClose()}
              openDeleteModal={() => console.log("")}
            />

            <div className={classes.imageInputAndNameAndAbbreviation}>
              {thumbnailTouched ? (
                <div
                  className={classes.imageViewerDiv}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <div
                    className={classes.removeThumbnailIcon}
                    onClick={() => removeThumbnail()}
                    style={{
                      display: isHovered ? "flex" : "none",
                    }}
                  >
                    <X size={18} />
                  </div>
                  <div className={classes.imageContentDiv}>
                    <img
                      className={classes.projectThumbnail}
                      src={
                        thumbnail
                          ? URL.createObjectURL(thumbnail)
                          : loggedInUser?.avatar
                      }
                    />
                  </div>
                </div>
              ) : (
                <div className={classes.cardContentDiv2}>
                  <input
                    type="file"
                    className={classes.imageInput}
                    accept="image/png, image/jpeg"
                    id="thumbnailUpload"
                    onChange={(e) => handleThumbnailUpload(e)}
                  />
                </div>
              )}

              <div style={{ marginLeft: "3%", width: "70%" }}>
                <div>
                  <span className={classes.inputLabel}>First Name</span>
                  <Asterisk size={12} color="#FF0000" weight="fill" />
                  <div className={classes.cardContentDiv3}>
                    <TextField
                      type="text"
                      InputProps={{
                        disableUnderline: true,
                        style: {
                          fontFamily: "Poppins",
                        },
                      }}
                      className={classes.cardContentInput1}
                      placeholder="Enter First name"
                      name="first_name"
                      onChange={formik.handleChange}
                      value={formik.values.first_name}
                      error={
                        formik.touched.first_name &&
                        Boolean(formik.errors.first_name)
                      }
                    />
                    {formik.errors.first_name && formik.touched.first_name ? (
                      <HelperText text={formik.errors.first_name} />
                    ) : null}
                  </div>
                </div>
                <div style={{ marginTop: "20px" }}>
                  <span className={classes.inputLabel}>Last Name</span>
                  <Asterisk size={12} color="#FF0000" weight="fill" />
                  <div className={classes.cardContentDiv3}>
                    <TextField
                      type="text"
                      InputProps={{
                        disableUnderline: true,
                        style: {
                          fontFamily: "Poppins",
                        },
                      }}
                      className={classes.cardContentInput1}
                      placeholder="Enter Last name"
                      name="last_name"
                      onChange={formik.handleChange}
                      value={formik.values.last_name}
                      error={
                        formik.touched.last_name &&
                        Boolean(formik.errors.last_name)
                      }
                    />
                    {formik.errors.last_name && formik.touched.last_name ? (
                      <HelperText text={formik.errors.last_name} />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <CardActions className={classes.cardAction}>
              <Button
                className={classes.doneButton}
                type="submit"
                value="Submit"
                size="small"
                disableElevation
              >
                {loader ? (
                  <CircularProgress style={{ width: "25px", height: "25px" }} />
                ) : (
                  <>Update Profile</>
                )}
              </Button>
            </CardActions>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
